module.exports = __webpack_public_path__ + "static/media/diamonds_6.52d2c814.png";